"use client";

import React from "react";
import { BedDouble, Eye, ConciergeBell, Bed, Coffee, Wifi, BookOpen, Wind, Crown, Users, Car } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const rooms = [{
  id: 1,
  title: "Collection Entry",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/entry_rib_boat.png"
}, {
  id: 2,
  title: "Collection Premium",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/premium_cruiser_yacht.png"
}, {
  id: 3,
  title: "Collection Gold",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/gold_luxury_superyacht.png"
}, {
  id: 4,
  title: "Elite Experience",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/elite_charter_ibiza.png"
}, {
  id: 5,
  title: "Bespoke Brokerage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/bespoke_yacht_consultancy.png"
}];
const roomAmenities = [{
  roomId: 1,
  iconName: "Wind",
  text: "Day Charter"
}, {
  roomId: 1,
  iconName: "Users",
  text: "Open Space"
}, {
  roomId: 1,
  iconName: "Car",
  text: "Fast Response"
}, {
  roomId: 2,
  iconName: "Bed",
  text: "Modern Cabins"
}, {
  roomId: 2,
  iconName: "Coffee",
  text: "Full Comfort"
}, {
  roomId: 2,
  iconName: "Wifi",
  text: "Smart Systems"
}, {
  roomId: 3,
  iconName: "Crown",
  text: "Maximum Luxury"
}, {
  roomId: 3,
  iconName: "ConciergeBell",
  text: "Private Crew"
}, {
  roomId: 3,
  iconName: "Eye",
  text: "Total Privacy"
}, {
  roomId: 4,
  iconName: "Crown",
  text: "VIP Access"
}, {
  roomId: 4,
  iconName: "Users",
  text: "Events"
}, {
  roomId: 4,
  iconName: "Car",
  text: "Chauffeur"
}, {
  roomId: 5,
  iconName: "BookOpen",
  text: "Expert Advice"
}, {
  roomId: 5,
  iconName: "Users",
  text: "Network"
}, {
  roomId: 5,
  iconName: "Eye",
  text: "Market Insight"
}];
const getIcon = (name: string) => {
  const commonClasses = "size-5 text-secondary shrink-0";
  switch (name) {
    case "BedDouble":
      return <BedDouble className={commonClasses} />;
    case "Eye":
      return <Eye className={commonClasses} />;
    case "ConciergeBell":
      return <ConciergeBell className={commonClasses} />;
    case "Bed":
      return <Bed className={commonClasses} />;
    case "Coffee":
      return <Coffee className={commonClasses} />;
    case "Wifi":
      return <Wifi className={commonClasses} />;
    case "BookOpen":
      return <BookOpen className={commonClasses} />;
    case "Wind":
      return <Wind className={commonClasses} />;
    case "Crown":
      return <Crown className={commonClasses} />;
    case "Users":
      return <Users className={commonClasses} />;
    case "Car":
      return <Car className={commonClasses} />;
    default:
      return null;
  }
};
export default function SanctuariesOfPeace() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224804" id="le-tre-classi-di-eccellenza" className="py-24 bg-background overflow-hidden dark" ref={ref}>
      <div className={`container mx-auto px-4 md:px-8 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
            Le Tre Classi di Eccellenza
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Dalla libertà dei day-charter dinamici alla privacy assoluta dei superyacht, offriamo una classificazione di mercato che riflette la nostra competenza tecnica e professionale.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full relative">
          <CarouselContent className="-ml-4 md:-ml-6">
            {rooms.map((room, i) => <CarouselItem key={room.id} data-index={i} className="pl-4 md:pl-6 basis-full sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <div className="group relative overflow-hidden transition-transform duration-700 hover:scale-[1.02] cursor-pointer h-full border border-secondary/30 hover:border-primary shadow-md">
                  <AspectRatio ratio={4 / 5} className="h-full">
                    <img src={room.image} alt={room.title} className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-700" />
                    
                    {}
                    <div className="absolute inset-0 bg-primary/40 transition-colors duration-700 group-hover:bg-primary/60 mix-blend-multiply" />
                    
                    {}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-70" />

                    {}
                    <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center z-10">
                      
                      {}
                      <h3 className="text-2xl md:text-3xl font-default text-white font-bold tracking-wide transition-transform duration-500 ease-out group-hover:-translate-y-10">
                        {room.title}
                      </h3>

                      {}
                      <div className="absolute top-1/2 left-0 w-full pt-2 opacity-0 translate-y-8 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:translate-y-0 flex flex-col items-center gap-4 pointer-events-none">
                        {roomAmenities.filter(a => a.roomId === room.id).map((amenity, j) => <div key={j} data-index={j} className="flex items-center gap-3 text-white/95">
                              {getIcon(amenity.iconName)}
                              <span className="text-xs tracking-widest uppercase font-default font-medium">
                                {amenity.text}
                              </span>
                            </div>)}
                      </div>
                      
                    </div>
                  </AspectRatio>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="hidden md:block">
            <CarouselPrevious className="absolute -left-5 lg:-left-12 top-1/2 -translate-y-1/2 size-14 rounded-md border border-secondary text-secondary bg-background/10 backdrop-blur-md hover:bg-primary hover:text-primary-foreground transition-colors duration-300 shadow-lg" />
            <CarouselNext className="absolute -right-5 lg:-right-12 top-1/2 -translate-y-1/2 size-14 rounded-md border border-secondary text-secondary bg-background/10 backdrop-blur-md hover:bg-primary hover:text-primary-foreground transition-colors duration-300 shadow-lg" />
          </div>
        </Carousel>
      </div>
    </section>;
}